$(function() {
  
      fetch('https://www.vitabiotics.com/browsing_context_suggestions.json').then(res => res.json()).then(data => {
       	if (data.detected_values.country.handle == "SG") {
       		Swal.fire({
       			showCloseButton: true,
       			confirmButtonText: 'Visit Store',
       			title: 'Singapore Store',
       			html: '<p style="line-height:1.5;">Fast, cost effective shipping direct from Singapore, check out Vitabiotics official Lazada store!</p>'
       		}).then((result) => {
       			if (result.isConfirmed) {
       				window.location.href = 'https://c.lazada.sg/t/c.bsB1V6?intent=false&fallback=true&url=https%3A%2F%2Fwww.lazada.sg%2Fshop%2Fvitabiotics';
       			}
       		});
       	}
       });

   
  
	$('#brand-slider').slick({
	    arrows: false,
		mobileFirst: true,
		autoplay: false,
		slidesToShow: 4,
      	slidesToScroll: 4,
    	arrows: false,
		infinite: false,
     
        row:2,
		responsive: [
          
          {
			breakpoint: 768 - 1,
			settings: {
				arrows: false,
				slidesToScroll: 1,
				centerMode: false,
				slidesToShow: 5,
            rows: 1,
				dots: false
			},
		}, {
			breakpoint: 1024 - 1,
			settings: {
				arrows: false,
				slidesToScroll: 1,
				slidesToShow: 4,
				centerMode: false,
                rows: 1,
              arrows: true
			},
		}, {
			breakpoint: 1240 - 1,
			settings: {
				arrows: false,
				slidesToScroll: 1,
				slidesToShow: 5,
				centerMode: false,
                rows: 1,
              arrows: true
			},
		}, ]
	});                    
	$('*[data-click="icon-0"]').addClass('yes');
	$('#vitabiotics-media').on('afterChange', function(event, slick, currentSlide) {
		$('.media-img .media_icon').each(function() {
			$(this).removeClass('yes');
		});
		$('*[data-click="icon-' + currentSlide + '"]').addClass('yes');
	});
	$('#vitabiotics-media').slick({
		arrows: false,
		mobileFirst: true,
		autoplay: true,
		slidesToShow: 1,
		autoplaySpeed: 3000,
		infinite: true,
		dots: true,
		responsive: [{
			breakpoint: 768 - 1,
			settings: {
				arrows: false,
				slidesToScroll: 1,
				centerMode: false,
				slidesToShow: 1,
				dots: true
			},
		}, {
			breakpoint: 1024 - 1,
			settings: {
				arrows: false,
				slidesToScroll: 1,
				slidesToShow: 1,
				centerMode: false
			},
		}, {
			breakpoint: 1240 - 1,
			settings: {
				arrows: false,
				slidesToScroll: 1,
				slidesToShow: 1,
				centerMode: false
			},
		}, ]
	});
	var dots = $('#vitabiotics-media .slick-dots li');
	dots.each(function(k, v) {
		$(this).find('button').addClass('icon-' + k);
	});
	$('.media_icon').click(function() {
		var $media = $(this).data('click');
		$('.' + $media).click();
		$('.media-img .media_icon').each(function() {
			$(this).removeClass('yes');
		});
		$(this).addClass('yes');
	});
	$('.tab').click(function() {
		var $section = $(this).data('section');
		if ($section == "multi") {
			$('#multi-section').addClass('show-section').removeClass('hide-section');
			$('#single-section').removeClass('show-section').addClass('hide-section');
			$('*[data-section="multi"]').addClass('active');
			$('*[data-section="single"]').removeClass('active');
			$('#best-multi-list').get(0).slick.setPosition()
		} else {
			$('#single-section').addClass('show-section').removeClass('hide-section');
			$('#multi-section').removeClass('show-section').addClass('hide-section');
			$('*[data-section="multi"]').removeClass('active');
			$('*[data-section="single"]').addClass('active');
			$('#best-single-list').get(0).slick.setPosition()
		}
	});                        
	$('#shop-by-list').slick({
		arrows: false,
		mobileFirst: true,
		autoplay: false,
		slidesToShow: 1,
		infinite: false,
		centerMode: true,
		centerPadding: '30px',
    
		responsive: [{
			breakpoint: 768 - 1,
			settings: {
				arrows: true,
				slidesToScroll: 1,
				centerMode: false,
				slidesToShow: 3,
                     	centerPadding: '30px',
				
			},
		}, {
			breakpoint: 1024 - 1,
			settings: {
				arrows: true,
				slidesToScroll: 1,
				slidesToShow: 4,
				centerMode: false
			},
		}, {
			breakpoint: 1240 - 1,
			settings: {
				arrows: true,
				slidesToScroll: 1,
				slidesToShow: 4,
				centerMode: false
     
			},
		} ]
    });
                     
        
                     
                     
	$('#best-multi-list').slick({
	arrows: false,
		mobileFirst: true,
		autoplay: false,
		slidesToShow: 2,
		slidesToScroll: 2,
		infinite: false,
		dots: true,
		responsive: [{
			breakpoint: 768 - 1,
			settings: {
				arrows: false,
				slidesToScroll: 1,
				centerMode: false,
				slidesToShow: 3,
     
	
				dots: true
			},
		}, {
			breakpoint: 1024 - 1,
			settings: {
				arrows: true,
				slidesToScroll: 4,
				slidesToShow: 4,
				centerMode: false,
				dots: false
			},
		}, {
			breakpoint: 1240 - 1,
			settings: {
				arrows: true,
				slidesToScroll: 4,
				slidesToShow: 4,
				centerMode: false,
           
				dots: false
			},
		}, ],
	});
  
  
  
  
  	$('#best-single-list').slick({
		arrows: false,
		mobileFirst: true,
		autoplay: false,
		slidesToShow: 2,
		autoplaySpeed: 3000,
		slidesToScroll: 2,
		infinite: false,
		dots: true,
		responsive: [{
			breakpoint: 768 - 1,
			settings: {
				arrows: false,
				slidesToScroll: 2,
				centerMode: false,
				slidesToShow: 2,
				dots: true
                     
			},
		}, {
			breakpoint: 1024 - 1,
			settings: {
				arrows: true,
				slidesToScroll: 4,
				slidesToShow: 4,
				centerMode: false,
				dots: false
			},
		}, {
			breakpoint: 1240 - 1,
			settings: {
				arrows: true,
				slidesToScroll: 4,
				slidesToShow: 4,
				centerMode: false,
				dots: false
			},
		}, ],
	});  
	$('#ha-list').slick({
		arrows: false,
		mobileFirst: true,
		autoplay: false,
		slidesToShow: 1,
	
		infinite: false,
		centerMode: true,
		centerPadding: '30px',
		responsive: [{
			breakpoint: 768 - 1,
			settings: {
				arrows: false,
				slidesToScroll: 3,
				centerMode: false,
				slidesToShow: 3,
				dots: true
			},
		}, {
			breakpoint: 1024 - 1,
			settings: {
				arrows: true,
				slidesToScroll: 4,
				slidesToShow: 4,
				centerMode: false
			},
		}, {
			breakpoint: 1240 - 1,
			settings: {
				arrows: true,
				slidesToScroll: 4,
				slidesToShow: 4,
				centerMode: false
			}
		}]
	});

});

if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}


$(window).on('pagehide', function() {
   $(window).scrollTop(0);
});

document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'hidden') {
    window.scrollTo(0, 0);
  }
});
